import { Model } from 'rwl-shared';
import {
    GeolocationUpdate,
    PortfolioSessionUpdateRequest,
} from 'rwl-shared/dist/models/portfolio/PortfolioUserSession';

export const TRACKING_SESSION_ID = 'rwl:session:id';
export const TRACKING_SHARE_ID = 'rwl:share:id';

export function createSessionUpdateRequest(
    geolocation: Model.PluginGeoLocation | 'Unavailable',
    userId?: string
): Model.PortfolioSessionUpdateRequest {
    return {
        geolocation: geolocation,
        location: undefined,
        id: window.localStorage.getItem(TRACKING_SESSION_ID) ?? undefined,
        referrer: document.referrer,
        shareId: window.localStorage.getItem(TRACKING_SHARE_ID) ?? undefined,
        userAgent: window.navigator.userAgent,
        userId: userId,
    };
}

export async function trackSession(
    url: string,
    geoLocation: GeolocationUpdate,
    userId: string | undefined
): Promise<string> {
    const request = createSessionUpdateRequest(geoLocation, userId);
    return await postSessionUpdate(url, request);
}
async function postSessionUpdate(
    url: string,
    request: PortfolioSessionUpdateRequest
) {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            Accept: 'application.json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
    });
    const body = await response.json();
    const sessionId = body.id;
    if (sessionId) {
        window.localStorage.setItem(TRACKING_SESSION_ID, sessionId);
    }
    return sessionId;
}
